
export interface ReferToneDto
{
    getAPartyMsisdn(): string;
    getToneId(): string;
    getToneName(): string;
    getLanguage(): string;
    getPackName(): string;
    getMsisdnList(): string[]; // Comma seperated msisdn if multiple
}

export class ReferToneDtoImpl implements ReferToneDto
{
    private aPartyMsisdn: string;
    private toneId: string;
    private toneName: string;
    private language: string;
    private packName: string;
    private msisdnList: string[];


    getPackName(): string
    {
        return this.packName;
    }

    setPackName(packName: string)
    {
        this.packName = packName;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    getMsisdnList(): string[] 
    {
        return this.msisdnList;
    }
    setMsisdnList(msisdnList: string[])
    {
        this.msisdnList = msisdnList;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getToneName(): string 
    {
        return this.toneName;
    }
    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/refertone/refertonedto.tsx